import React from "react"
import styled, { createGlobalStyle } from "styled-components"

export const THEME_CLASSNAMES = {
  colors: {
    background: {
      primary: "vibez-bg-primary",
    },
    border: {
      primary: "vibez-border-primary",
    },
    fontColor: {
      primary: "vibez-font-color-primary",
    },
  },
} as const

const GlobalBrandThemes = createGlobalStyle`
  .${THEME_CLASSNAMES.colors.background.primary} {
    background: ${(props) => props.theme.colors.primary}
  }
  .${THEME_CLASSNAMES.colors.border.primary} {
    border-color: ${(props) => props.theme.colors.primary}
  }
  .${THEME_CLASSNAMES.colors.fontColor.primary} {
    color: ${(props) => props.theme.colors.primary}
  }
`

const BrandRoot = styled("div")`
  font-family: ${(props) => props.theme.fontFamily.primary};
  display: contents;
`

interface Props extends React.HTMLAttributes<HTMLDivElement> {}
export const BrandThemes = (props: Props) => {
  return (
    <>
      <BrandRoot {...props} />
      <GlobalBrandThemes />
    </>
  )
}
